<div id="app-wrapper">
  <app-status-modal></app-status-modal>
  <router-outlet></router-outlet>
</div>
